module.exports = __webpack_public_path__ + "img/maria-schwarz.625d9728.jpg";